/**
 * Defined all service info ---
 */
export default {
    getInfoCompany: {
        biz: 'admin',
        object: 'companies',
        funct: 'get_by_id',
    },
    editInfoCompany: {
        biz: 'admin',
        object: 'companies',
        funct: 'update',
    },
    resetPassword: {
        biz: 'admin',
        object: 'authens',
        funct: 'change_pass_user',
    },
    changePasswordAdmin: {
        biz: 'admin',
        object: 'authens',
        funct: 'change_pass_adm',
    },
    login: {
        biz: 'admin',
        object: 'authens',
        funct: 'login',
    },
    loginRFID: {
        biz: 'admin',
        object: 'authens',
        funct: 'login_rfid',
    },
    loginHikvision: {
        biz: 'admin',
        object: 'authens',
        funct: 'login_hikvision',
    },
    logout: {
        biz: 'admin',
        object: 'authens',
        funct: 'logout',
    },
    forgot: {
        biz: 'admin',
        object: 'authens',
        funct: 'forgot_pass',
    },
    permissions: {
        biz: 'admin',
        object: 'permissions',
        funct: 'get_all',
    },
    updatePermissions: {
        biz: 'admin',
        object: 'permissions',
        funct: 'update',
    },
    changePass: {
        biz: 'admin',
        object: 'authens',
        funct: 'change_pass_user',
    },
    request_change_status: {
        biz: 'admin',
        object: 'transactions',
        funct: 'request_change_status',
    },
    reject_request: {
        biz: 'admin',
        object: 'transactions',
        funct: 'reject_request',
    },
    approve_request: {
        biz: 'admin',
        object: 'transactions',
        funct: 'approve_request',
    },
    request_grinding: {
        biz: 'admin',
        object: 'transactions',
        funct: 'request_grinding',
    },
    confirm_grinding: {
        biz: 'admin',
        object: 'transactions',
        funct: 'confirm_grinding',
    },
    adminGetCheckDepreciation: {
        biz: 'admin',
        object: 'transactions',
        funct: 'admin_get_check_depreciation',
    },
    adminPutCheckDepreciation: {
        biz: 'admin',
        object: 'transactions',
        funct: 'admin_put_check_depreciation',
    },
    reviewRequestDevice: {
        biz: 'admin',
        object: 'transactions',
        funct: 'review_request_device',
    },
    forgotPass: {
        biz: 'admin',
        object: 'authens',
        funct: 'fotgot_pass',
    },
    // =============== Lấy thời gian chênh lệch giữa Local và Hikvision=================
    getTimeDifference: {
        biz: 'admin',
        object: 'authens',
        funct: 'get_time_difference',
    },
    // =============== screen =================
    getAllScreen: {
        biz: 'admin',
        object: 'screens',
        funct: 'get_list',
    },
    getByIdScreen: {
        biz: 'admin',
        object: 'screens',
        funct: 'get_by_id',
    },
    createScreen: {
        biz: 'admin',
        object: 'screens',
        funct: 'insert',
    },
    updateScreen: {
        biz: 'admin',
        object: 'screens',
        funct: 'update',
    },
    deleteScreen: {
        biz: 'admin',
        object: 'screens',
        funct: 'delete',
    },
    processScreenGroup: {
        biz: 'admin',
        object: 'screens',
        funct: 'process_screens_group',
    },
    updateActiveScreenGroup: {
        biz: 'admin',
        object: 'screens',
        funct: 'update_active',
    },
    getListScreenGroup: {
        biz: 'admin',
        object: 'screens',
        funct: 'get_list_screens_group',
    },
    // =============== Group Permission =================
    createGroup: {
        biz: 'admin',
        object: 'permissions',
        funct: 'insert_group',
    },
    updateGroup: {
        biz: 'admin',
        object: 'permissions',
        funct: 'update_group',
    },
    deleteGroup: {
        biz: 'admin',
        object: 'permissions',
        funct: 'delete_group',
    },
    getAllGroup: {
        biz: 'admin',
        object: 'permissions',
        funct: 'get_list_group',
    },
    processGroupPermission: {
        biz: 'admin',
        object: 'permissions',
        funct: 'process_group_permission',
    },
    getGroupPermission: {
        biz: 'admin',
        object: 'permissions',
        funct: 'get_by_id_group_permission',
    },
    processGroupUser: {
        biz: 'admin',
        object: 'permissions',
        funct: 'process_group_user',
    },
    getGroupUser: {
        biz: 'admin',
        object: 'permissions',
        funct: 'get_by_id_group_user',
    },
    // =============== cabinet =================
    createCabinet: {
        biz: 'admin',
        object: 'cabinets',
        funct: 'insert',
    },
    getAllCabinet: {
        biz: 'admin',
        object: 'cabinets',
        funct: 'get_all',
    },
    getAllCabinetSp: {
        biz: 'admin',
        object: 'cabinets',
        funct: 'get_all_sp',
    },
    deleteCabinet: {
        biz: 'admin',
        object: 'cabinets',
        funct: 'delete',
    },
    updateCabinet: {
        biz: 'admin',
        object: 'cabinets',
        funct: 'update',
    },
    lockCabinet: {
        biz: 'admin',
        object: 'cabinets',
        funct: 'block',
    },
    sessionChangeCabinet: {
        biz: 'admin',
        object: 'cabinets',
        funct: 'session_change_cabinet',
    },
    // ====================== Drawer =================
    createdrawer: {
        biz: 'admin',
        object: 'drawers',
        funct: 'insert',
    },
    getAlldrawer: {
        biz: 'admin',
        object: 'drawers',
        funct: 'get_all',
    },
    getAlldrawerSp: {
        biz: 'admin',
        object: 'drawers',
        funct: 'get_all_sp',
    },
    getListDrawerAndSuggestCell: {
        biz: 'admin',
        object: 'drawers',
        funct: 'get_list_drawer_and_suggest_cell',
    },
    deletedrawer: {
        biz: 'admin',
        object: 'drawers',
        funct: 'delete',
    },
    updatedrawer: {
        biz: 'admin',
        object: 'drawers',
        funct: 'update',
    },
    lockDrawer: {
        biz: 'admin',
        object: 'drawers',
        funct: 'block',
    },
    getListDrawerHaveDeviceCd: {
        biz: 'admin',
        object: 'drawers',
        funct: 'get_list_drawer_have_device_cd',
    },
    // =====================BOX========================
    createbox: {
        biz: 'admin',
        object: 'cells',
        funct: 'insert',
    },
    getAllbox: {
        biz: 'admin',
        object: 'cells',
        funct: 'get_all',
    },
    getAllboxSp: {
        biz: 'admin',
        object: 'cells',
        funct: 'get_all_sp',
    },
    deletebox: {
        biz: 'admin',
        object: 'cells',
        funct: 'delete',
    },
    updatebox: {
        biz: 'admin',
        object: 'cells',
        funct: 'update',
    },
    lockbox: {
        biz: 'admin',
        object: 'cells',
        funct: 'block',
    },
    export: {
        biz: 'admin',
        object: 'cells',
        funct: 'export',
    },

    // =====================IOT OHNO ========================

    checkHeartbeat: {
        biz: 'common',
        object: 'CBNOHNO',
        funct: 'heartbeat',
    },
    checkHeartbeatCabinetV2: {
        biz: 'common',
        object: 'CBNV3',
        funct: 'heartbeat',
    },
    //   checkHeartbeat: {
    //   biz: "common",
    //   object: "cells",
    //   funct: "heartbeat",
    // },
    openCabinetIOT: {
        biz: 'common',
        object: 'CBNOHNO',
        funct: 'masterlock',
    },
    closeCabinetIOT: {
        biz: 'common',
        object: 'CBNOHNO',
        funct: 'masterlock',
    },
    closeCellIOT: {
        biz: 'common',
        object: 'CBNOHNO',
        funct: 'close_cell',
    },
    closeCellIOTCabinetV2: {
        biz: 'common',
        object: 'CBNV3',
        funct: 'close_cell',
    },
    checkStatusCell: {
        biz: 'common',
        object: 'CBNV3',
        funct: 'check_rack',
    },
    openCellIOT: {
        biz: 'common',
        object: 'CBNOHNO',
        funct: 'open_cell',
    },
    openCellIOTCabinetV2: {
        biz: 'common',
        object: 'CBNV3',
        funct: 'open_cell',
    },
    getRFID: {
        biz: 'common',
        object: 'CBNOHNO',
        funct: 'rfid_request',
    },
    getRFIDCabinetV2: {
        biz: 'common',
        object: 'CBNV3',
        funct: 'rfid_request',
    },
    loginIOT: {
        biz: 'common',
        object: 'CBNV3',
        funct: 'log_in',
    },
    logoutIOT: {
        biz: 'common',
        object: 'CBNV3',
        funct: 'log_out',
    },

    // =====================DEPARTMENT ========================

    createdepartment: {
        biz: 'admin',
        object: 'departments',
        funct: 'insert',
    },
    getAllUserList: {
        biz: 'admin',
        object: 'authens',
        funct: 'get_all_list',
    },
    getAlldepartment: {
        biz: 'admin',
        object: 'departments',
        funct: 'get_all',
    },
    get_by_group_level: {
        biz: 'admin',
        object: 'departments',
        funct: 'get_by_group_level',
    },
    deletedepartment: {
        biz: 'admin',
        object: 'departments',
        funct: 'delete',
    },
    updatedepartment: {
        biz: 'admin',
        object: 'departments',
        funct: 'update',
    },
    // =====================DEVICE ========================

    createDevice: {
        biz: 'admin',
        object: 'devices',
        funct: 'insert',
    },
    getAllDevice: {
        biz: 'admin',
        object: 'devices',
        funct: 'get_all',
    },
    getAllDeviceSp: {
        biz: 'admin',
        object: 'devices',
        funct: 'get_all_sp',
    },
    getAllDeviceSpByNm: {
        biz: 'admin',
        object: 'devices',
        funct: 'get_devices_list_sp_by_nm',
    },
    deleteDevice: {
        biz: 'admin',
        object: 'devices',
        funct: 'delete',
    },
    updateDevice: {
        biz: 'admin',
        object: 'devices',
        funct: 'update',
    },
    getAllDeviceTake: {
        biz: 'admin',
        object: 'devices',
        funct: 'get_take_all',
    },
    getAllDeviceTakeDrawer: {
        biz: 'admin',
        object: 'devices',
        funct: 'get_take_drawer',
    },
    getAllDeviceTakeCabinet: {
        biz: 'admin',
        object: 'devices',
        funct: 'get_take_cabinet',
    },
    getAllDeviceBorrow: {
        biz: 'admin',
        object: 'devices',
        funct: 'get_borrow_all',
    },
    getAllDeviceBorrowDraw: {
        biz: 'admin',
        object: 'devices',
        funct: 'get_borrow_drawer',
    },
    getAllDeviceCabinet: {
        biz: 'admin',
        object: 'devices',
        funct: 'get_borrow_cabinet',
    },
    getByDeviceCode: {
        biz: 'admin',
        object: 'devices',
        funct: 'get_by_device_code',
    },
    getListDeviceBase: {
        biz: 'admin',
        object: 'devices',
        funct: 'get_list_device_base',
    },
    getListDeviceLocation: {
        biz: 'admin',
        object: 'devices',
        funct: 'get_list_device_location',
    },
    getAllDeviceMoreGroup: {
        biz: 'admin',
        object: 'devices',
        funct: 'get_all_with_more_group',
    },
    // =====================TRANSITION ========================
    actionDeviceOnline: {
        biz: 'admin',
        object: 'stores_onl',
        funct: 'insert',
    },
    checkLocationDevice: {
        biz: 'admin',
        object: 'stores_onl',
        funct: 'check_location_device_by_cell_id',
    },
    changeQtyDeviceOnline: {
        biz: 'admin',
        object: 'stores_onl',
        funct: 'update',
    },
    changeQtyDeviceOnlineUpdate: {
        biz: 'admin',
        object: 'stores_onl',
        funct: 'update_sl',
    },
    deleteDeviceOnline: {
        biz: 'admin',
        object: 'stores_onl',
        funct: 'delete',
    },
    getDeviceOnline: {
        biz: 'admin',
        object: 'stores_onl',
        funct: 'get_all',
    },
    getListRegisterDeviceOnline: {
        biz: 'admin',
        object: 'stores_onl',
        funct: 'get_list_register_device_online',
    },
    actionDeviceTransaction: {
        biz: 'admin',
        object: 'transactions',
        funct: 'insert',
    },
    admin_get_in_cell: {
        biz: 'admin',
        object: 'transactions',
        funct: 'admin_get_in_cell',
    },
    actionReportDamaged: {
        biz: 'admin',
        object: 'transactions',
        funct: 'report_damaged',
    },
    actionConfirmRepaired: {
        biz: 'admin',
        object: 'transactions',
        funct: 'confirm_repaired',
    },
    getDeviceTransaction: {
        biz: 'admin',
        object: 'transactions',
        funct: 'get_all',
    },
    getListEbrByBussiness: {
        biz: 'admin',
        object: 'transactions',
        funct: 'get_list_ebr_by_bussiness',
    },
    get_list_etk_by_status: {
        biz: 'admin',
        object: 'transactions',
        funct: 'get_list_etk_by_status',
    },

    getHisTransaction: {
        biz: 'admin',
        object: 'transactions',
        funct: 'get_all_his',
    },
    getPepleTransaction: {
        biz: 'admin',
        object: 'transactions',
        funct: 'get_all_ebr',
    },
    getGiveTransaction: {
        biz: 'admin',
        object: 'transactions',
        funct: 'get_all_need_ebr',
    },
    getGiveTransactionByDevice: {
        biz: 'admin',
        object: 'transactions',
        funct: 'get_transaction_ebr_igb_by_device',
    },
    getPepleTransaction_ETK: {
        biz: 'admin',
        object: 'transactions',
        funct: 'get_all_etk',
    },
    device_not_yet_review: {
        biz: 'admin',
        object: 'transactions',
        funct: 'device_not_yet_review',
    },
    // ===================== GROUP DEVICE ========================

    creategroup_devices: {
        biz: 'admin',
        object: 'group_devices',
        funct: 'insert',
    },
    getAllgroup_devices: {
        biz: 'admin',
        object: 'group_devices',
        funct: 'get_all_sp',
    },
    getIDgroup_devices: {
        biz: 'admin',
        object: 'group_devices',
        funct: 'get_by_id',
    },
    getAllgroup_devicesUser: {
        biz: 'admin',
        object: 'group_devices',
        funct: 'get_all',
    },
    deletegroup_devices: {
        biz: 'admin',
        object: 'group_devices',
        funct: 'delete',
    },
    updategroup_devices: {
        biz: 'admin',
        object: 'group_devices',
        funct: 'update',
    },
    getPropertySp: {
        biz: 'admin',
        object: 'properties_devices',
        funct: 'get_all_sp',
    },
    getProperty: {
        biz: 'admin',
        object: 'properties_devices',
        funct: 'get_all',
    },
    insertProperty: {
        biz: 'admin',
        object: 'properties_devices',
        funct: 'insert',
    },
    updateProperty: {
        biz: 'admin',
        object: 'properties_devices',
        funct: 'update',
    },
    deleteProperty: {
        biz: 'admin',
        object: 'properties_devices',
        funct: 'delete',
    },

    // excel
    deleteTempDeviceLocation: {
        biz: 'admin',
        object: 'devices',
        funct: 'delete_temp_device_location',
    },
    importTempListDeviceLocation: {
        biz: 'admin',
        object: 'devices',
        funct: 'import_temp_list_device_location',
    },
    submitTempDeviceLocation: {
        biz: 'admin',
        object: 'devices',
        funct: 'submit_temp_device_location',
    },
    insertExcelDevice: {
        biz: 'admin',
        object: 'devices',
        funct: 'imports',
    },
    submitExcelDevice: {
        biz: 'admin',
        object: 'devices',
        funct: 'submit',
    },
    delExcelDevice: {
        biz: 'admin',
        object: 'devices',
        funct: 'delete_temp',
    },
    // excel groups devices
    delExcelGroups: {
        biz: 'admin',
        object: 'group_devices',
        funct: 'delete_temp_group',
    },
    insertExcelGroups: {
        biz: 'admin',
        object: 'group_devices',
        funct: 'submit_temp_group',
    },
    uploadExcelGroups: {
        biz: 'admin',
        object: 'group_devices',
        funct: 'imports_temp_group',
    },
    // excel groups devices
    delExcelGroupsProperty: {
        biz: 'admin',
        object: 'group_devices',
        funct: 'delete_properties',
    },
    insertExcelGroupsProperty: {
        biz: 'admin',
        object: 'group_devices',
        funct: 'submit_properties',
    },
    uploadExcelGroupsProperty: {
        biz: 'admin',
        object: 'group_devices',
        funct: 'imports_properties',
    },
    // =====================SUPPLIER ========================

    createsupplier: {
        biz: 'admin',
        object: 'suppliers',
        funct: 'insert',
    },
    getAllsupplier: {
        biz: 'admin',
        object: 'suppliers',
        funct: 'get_all_sp',
    },
    getAllsupplierUser: {
        biz: 'admin',
        object: 'suppliers',
        funct: 'get_all',
    },
    deletesupplier: {
        biz: 'admin',
        object: 'suppliers',
        funct: 'delete',
    },
    updatesupplier: {
        biz: 'admin',
        object: 'suppliers',
        funct: 'update',
    },

    // excel
    uploadsupplier: {
        biz: 'admin',
        object: 'suppliers',
        funct: 'imports_temp',
    },
    insertExcelsupplier: {
        biz: 'admin',
        object: 'suppliers',
        funct: 'submit',
    },
    deleteUploadsupplier: {
        biz: 'admin',
        object: 'suppliers',
        funct: 'delete_temp',
    },

    // =====================STAFF ========================

    createstaff: {
        biz: 'admin',
        object: 'authens',
        funct: 'sign_up',
    },
    importStaff: {
        biz: 'admin',
        object: 'users',
        funct: 'imports_temp',
    },
    importStaffSubmit: {
        biz: 'admin',
        object: 'users',
        funct: 'submit',
    },
    getAllstaff: {
        biz: 'admin',
        object: 'authens',
        funct: 'get_all',
    },
    getAllAdmmin: {
        biz: 'admin',
        object: 'authens',
        funct: 'get_all_admin',
    },
    lockstaff: {
        biz: 'admin',
        object: 'authens',
        funct: 'lock_user',
    },
    getByIdStaffBase: {
        biz: 'admin',
        object: 'authens',
        funct: 'get_by_id',
    },
    updatestaff: {
        biz: 'admin',
        object: 'users',
        funct: 'update',
    },
    update_admin: {
        biz: 'admin',
        object: 'users',
        funct: 'update_admin',
    },
    deleteTabelExcel: {
        biz: 'admin',
        object: 'users',
        funct: 'delete_temp',
    },
    getListUserBase: {
        biz: 'admin',
        object: 'users',
        funct: 'get_list_user',
    },
    getByIdUser: {
        biz: 'admin',
        object: 'users',
        funct: 'get_by_id',
    },
    syncCardnoFaceIdHik: {
        biz: 'admin',
        object: 'users',
        funct: 'sync_cardno_faceid',
    },
    checkVersion: {
        biz: 'admin',
        object: 'users',
        funct: 'check_version',
    },

    // ===================== NOTIFICATION ========================
    getAllNotification: {
        biz: 'admin',
        object: 'notify',
        funct: 'get_all',
    },
    readerNotification: {
        biz: 'admin',
        object: 'notify',
        funct: 'update',
    },
    checkWarning: {
        biz: 'admin',
        object: 'notify',
        funct: 'checking',
    },
    insert: {
        biz: 'admin',
        object: 'notify',
        funct: 'insert',
    },
    getListNotification: {
        biz: 'admin',
        object: 'notify',
        funct: 'get_list_notification',
    },
    getListWarning: {
        biz: 'admin',
        object: 'notify',
        funct: 'get_list_warning',
    },

    // ===================== REPORT ========================
    getReportDepartment: {
        biz: 'admin',
        object: 'statistics',
        funct: 'get_all_sp',
    },
    getStatistics: {
        biz: 'admin',
        object: 'statistics',
        funct: 'get_all',
    },
    getStatisticsAll: {
        biz: 'admin',
        object: 'statistics',
        funct: 'get_statistics_all',
    },
    getStatisticsHistory: {
        biz: 'admin',
        object: 'statistics',
        funct: 'get_all_his_inv',
    },
    getStocking: {
        biz: 'admin',
        object: 'statistics',
        funct: 'get_stocktaking',
    },
    checkStatisticChecking: {
        biz: 'admin',
        object: 'statistics',
        funct: 'get_check_inv',
    },
    setStatisticChecking: {
        biz: 'admin',
        object: 'statistics',
        funct: 'set_check_inv',
    },
    insertStatisticChecking: {
        biz: 'admin',
        object: 'statistics',
        funct: 'insert_his_inv',
    },
    getStatisticsListEtk: {
        biz: 'admin',
        object: 'statistics',
        funct: 'get_statistics_list_etk',
    },
    getStatisticsListEtkAndCdr: {
        biz: 'admin',
        object: 'statistics',
        funct: 'get_statistics_list_etk_and_cdr',
    },
    getStatisticsListRdeAndEbr: {
        biz: 'admin',
        object: 'statistics',
        funct: 'get_list_rde_and_ebr',
    },
    getStatisticsDepartment_2month: {
        biz: 'admin',
        object: 'statistics',
        funct: 'get_statistics_etk_month',
    },
    get_expense_and_amount_etk: {
        biz: 'admin',
        object: 'statistics',
        funct: 'get_expense_and_amount_etk',
    },
    get_device_etk: {
        biz: 'admin',
        object: 'statistics',
        funct: 'get_device_etk',
    },
    // report warehouse

    reportWarehouse: {
        biz: 'admin',
        object: 'statistics',
        funct: 'get_stock_report',
    },

    // ===================== CONFIG DEVICE INFO ========================

    getAllConfigDevice: {
        biz: 'admin',
        object: 'config_devices',
        funct: 'get_list',
    },
    getByIDConfigDevice: {
        biz: 'admin',
        object: 'config_devices',
        funct: 'get_by_id',
    },
    insertConfigDevice: {
        biz: 'admin',
        object: 'config_devices',
        funct: 'insert',
    },
    updateConfigDevice: {
        biz: 'admin',
        object: 'config_devices',
        funct: 'update',
    },
    deleteConfigDevice: {
        biz: 'admin',
        object: 'config_devices',
        funct: 'delete',
    },
    updateActiveConfigDevice: {
        biz: 'admin',
        object: 'config_devices',
        funct: 'update_active',
    },
    // =============== Cập nhật thời gian chênh lệch giữa Local và Hikvision=================
    updateDeltaTime: {
        biz: 'admin',
        object: 'config_devices',
        funct: 'update_delta_time',
    },
    // =============== ĐỒNG BỘ TOÀN BỘ DANH SÁCH NGƯỜI DÙNG HIỆN TẠI LÊN HIKVISION =================
    syncDataUsers: {
        biz: 'admin',
        object: 'sync_hikvision',
        funct: 'sync_data_users',
    },
    closeHik: {
        biz: 'admin',
        object: 'authens',
        funct: 'close_hik',
    },

    // ===================== REGISTER INFO USERS WITH DEVICE ========================
    registerFaceID: {
        biz: 'admin',
        object: 'users',
        funct: 'register_faceid',
    },
    deleteFaceID: {
        biz: 'admin',
        object: 'users',
        funct: 'delete_faceid',
    },
    registerCardNo: {
        biz: 'admin',
        object: 'users',
        funct: 'register_card_no',
    },
    updateCardNo: {
        biz: 'admin',
        object: 'users',
        funct: 'update_card_no',
    },
    deleteCardNo: {
        biz: 'admin',
        object: 'users',
        funct: 'delete_card_no',
    },
    // ===================== EMAIL SMTP ========================
    processSMTP: {
        biz: 'admin',
        object: 'email_smtp',
        funct: 'process',
    },
    getByIdSMTP: {
        biz: 'admin',
        object: 'email_smtp',
        funct: 'get_by_id_smtp',
    },
    changePassEmailSMTP: {
        biz: 'admin',
        object: 'email_smtp',
        funct: 'change_pass_email',
    },
    sendEmailSMTP: {
        biz: 'admin',
        object: 'email_smtp',
        funct: 'send_email',
    },
    insertEmailReceive: {
        biz: 'admin',
        object: 'email_smtp',
        funct: 'insert_email_receive',
    },
    deleteEmailReceive: {
        biz: 'admin',
        object: 'email_smtp',
        funct: 'delete_email_receive',
    },
    getListEmailReceive: {
        biz: 'admin',
        object: 'email_smtp',
        funct: 'get_list_email_receive',
    },
    sendEmailDevice: {
        biz: 'admin',
        object: 'email_smtp',
        funct: 'send_email_device',
    },
    giveDeviceTransaction: {
        biz: 'admin',
        object: 'transactions',
        funct: 'give_borrow',
    },
    // =========================================== REQUEST DEVICE ===========================================
    getListRequestDevice: {
        biz: 'admin',
        object: 'request_device',
        funct: 'get_list',
    },
    getOneRequestDevice: {
        biz: 'admin',
        object: 'request_device',
        funct: 'get_by_id',
    },
    addRequestDevice: {
        biz: 'admin',
        object: 'request_device',
        funct: 'insert',
    },
    deleteRequestDevice: {
        biz: 'admin',
        object: 'request_device',
        funct: 'delete',
    },
    changeStatusRequestDevice: {
        biz: 'admin',
        object: 'request_device',
        funct: 'change_status',
    },
    getDeviceRequestDevice: {
        biz: 'admin',
        object: 'request_device',
        funct: 'get_device',
    },
    changeStatusChangeDevice: {
        biz: 'admin',
        object: 'request_device',
        funct: 'change_status_change_device',
    },
    requestChangeDevice: {
        biz: 'admin',
        object: 'request_device',
        funct: 'request_change_device',
    },
    requestChangeDeviceWithIdTransaction: {
        biz: 'admin',
        object: 'request_device',
        funct: 'request_change_device_with_id_transaction',
    },
    getItemChangeDeviceWithIdTransaction: {
        biz: 'admin',
        object: 'request_device',
        funct: 'get_item_change_device_with_transaction_id',
    },
    getListRequestChangeDevice: {
        biz: 'admin',
        object: 'request_device',
        funct: 'get_list_request_change_device',
    },
    getItemChangeDevice: {
        biz: 'admin',
        object: 'request_device',
        funct: 'get_item_change_device',
    },
    takeDeviceFromChangeDevice: {
        biz: 'admin',
        object: 'request_device',
        funct: 'take_device_from_change_device',
    },
    adminTakeOrPutCangeDevice: {
        biz: 'admin',
        object: 'request_device',
        funct: 'admin_take_or_put_change_device',
    },
};
